import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/home/HeroBanner";
import Counters from "../components/Counters";
import CourseCarousel from "../components/home/CourseCarousel";
import WhyChooseUs from "../components/home/WhyChooseUs";
import Certification from "../components/Certification";
import MusicMasteryCourse from "../components/home/MusicMasteryCourse";
import OperaTrainingCenter from "../components/home/OperaTrainingCenter";
import Testimonials from "../components/Testimonials";
import LatestBlog from "../components/LatestBlog";
import Contact from "../components/Contact";
import InstaConnect from "../components/InstaConnect";
import MiniFaq from "../components/MiniFaq";
import GetStarted from "../components/home/GetStarted";
import AboutUs from '../components/home/AboutUs';


export default function Home() {
    return (
        <>
            <Header />

            <HeroBanner />

            <section id="counters-section">
                <Counters />
            </section>

            <AboutUs />
            
            <CourseCarousel />

            <GetStarted />

            <WhyChooseUs />

            <Certification />

            <MusicMasteryCourse />

            <OperaTrainingCenter />

            <Testimonials />

            <LatestBlog />

            <Contact />

            <InstaConnect />

            <MiniFaq />

            <Footer />
        </>
    );
}